import { render, staticRenderFns } from "./BusinessCategorySuggestions.vue?vue&type=template&id=1d18cb32"
import script from "./BusinessCategorySuggestions.vue?vue&type=script&lang=js"
export * from "./BusinessCategorySuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports